import { ENV } from './env'
export default {
  ...ENV,
  env: 'STAGING'
}
